'use strict';

angular.module('study.menu', [
    'study-environment',
]);
